export default "__VITE_ASSET__B5jTI7Rl__"